<template>
  <div class="sph-qrcode">
    <div class="sph-survey-header">
      <div class="sph-survey-header-content">
        <template v-if="type === 'kehu'">
          <h2>
            SUBMITTED
          </h2>
          <h2>
            SUCCESSFULLY
          </h2>
          <h3>
            提交成功
          </h3>
        </template>

        <h3 v-else>
          您提交的信息我们已经收到，我们会在工作时间2小时内与您联系
        </h3>
      </div>
    </div>
    <div class="sph-qrcode-main">
      <img
        v-if="type === 'kehu'"
        :src="info.bind_qrcode_url"
        alt=""
      />
      <img
        v-else
        src="@/assets/images/sph/qr_code.jpg"
        alt=""
      />
    </div>
    <div class="sph-survey-header">
      <h3 v-if="type === 'kehu'">
        下载客户绑定二维码
      </h3>
      <h3 v-else>
        长按识别二维码，关注“上海圆和新太会诊服务”公众号，获取最新资讯
      </h3>
    </div>
  </div>
</template>

<script>
import menZhenService from "@/apis/menZhen/index.js";

export default {
  data() {
    return {
      type: "neijing",
      info: {},
    };
  },
  async created() {
    if (this.$route.name === "WorkOrderSuccess") {
      this.workMyWorkDetail();
      this.type = "kehu";
    }
  },
  methods: {
    workMyWorkDetail() {
      const params = {
        work_id: this.$route.query.work_id,
      };
      menZhenService.workDetail(params).then((res) => {
        this.info = res;
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.sph-qrcode {
  background: url("../../assets/images/sph/qrcode_bg.png");
  background-size: 100% 100%;
  height: 100vh;
  color: #fff;
  padding: 30px 33px;
  box-sizing: border-box;
}
.sph-survey-header {
  h2 {
    margin: 0;
  }
  h3 {
    margin-top: 10px;
  }
}
.sph-qrcode-main {
  img {
    width: 100%;
    max-width: 350px;
  }
  margin: 30px 0;
}
</style>